import styled from 'styled-components'

import { media } from '@/theme/common'

// Note: 1.5x the default 16rem table filter width; a `&&` wrapper outranks the table's own
// `> *` width rule without an inline style
export const FeatureFilter = styled.div`
  && {
    flex-shrink: 0;
    width: 24rem;
    max-width: 100%;

    ${media.down('sm')} {
      width: 100%;
    }
  }
`
